import recipients from "@/store/app/google/settings/recipients"

export default {
  namespaced: true,

  actions: {},

  modules: {
    recipients,
  }
}
